/**
 * Copyright Mántum All Rights Reserved.
 */
import Internal from '../internal/select';
import ReactSelect from 'react-select';
import { forwardRef } from 'react';

import type {
    DataSource,
    Detail,
    Error,
    Event,
    Filter,
    Group,
    HttpError,
    Option,
    Options,
    Result,
    Validation,
    WebSocket
} from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        entity?: string;
        filter?: Filter;
        group?: Group;
        menuShouldScrollIntoView?: boolean;
        namespace?: string;
        options?: Option<string>;
        placement?: 'auto' | 'top' | 'bottom';
        position?: 'fixed' | 'absolute';
        preselect?: boolean;
        refresh?: number;
        result?: Result;
        revalidate?: boolean;
        searchable?: boolean;
        webSocket?: WebSocket;
    };
    dataSource?: Options<unknown> | DataSource;
    disabled?: boolean;
    error?: boolean;
    event?: Event;
    instanceId?: number | string;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: Option<unknown> | unknown) => void;
    onMessage?: (
        title: string,
        errors?: HttpError | string[] | Error,
        success?: boolean
    ) => void;
    onListener?: (values?: Record<string, unknown>) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: Option<unknown>;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Select(props, ref) {
        // prettier-ignore
        const {
            advanced = {}
        } = props

        // prettier-ignore
        const {
            searchable = false
        } = advanced

        return (
            <Internal
                {...props}
                ref={ref}
                render={ReactSelect}
                searchable={searchable}
            />
        );
    }
);
